// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
// import { getAnalytics } from 'firebase/analytics';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { getUA, isMobile, mobileModel, osName } from 'react-device-detect';
import firebase from 'firebase/compat/app';
import 'firebase/compat/messaging';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyDn3nYcs5OlnFkEQVFCh8lCgl6zYI5Ut2M',
  authDomain: 'reco-push-a5f41.firebaseapp.com',
  projectId: 'reco-push-a5f41',
  storageBucket: 'reco-push-a5f41.appspot.com',
  messagingSenderId: '968280822424',
  appId: '1:968280822424:web:ed9a83efc048d99892b6ed',
  measurementId: 'G-WWENGCVGKZ'
};

const vapidKey =
  'BNKBv4wNHd_AxB4z7hJCzq-bzgfubvG7xjJkT--dHRevvCOFf5GgLrcacGV-u2Xf45afrx5ekOMTR6iLy5TfQM0';

// Initialize Firebase
/*const app =*/
initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const messaging = getMessaging();

//....

//....
export async function request(sendDeviceInfoRequestMutation) {
  try {
    const token = await getToken(messaging, { vapidKey: vapidKey });
    if (token) {
      sendDeviceInfoRequestMutation.mutate({
        device_id: token,
        is_mobile: isMobile,
        os: osName,
        user_agent: getUA,
        device_model: mobileModel
      });
    } else {
      console.log(
        'No registration token available. Request permission to generate one.'
      );
    }
    return true;
  } catch (error) {
    console.log('An error occurred while retrieving token. ', error);
    return false;
  }
}

export async function getPermissionStatus() {
  if (firebase.messaging.isSupported()) {
    const { state } = await navigator.permissions.query({
      name: 'notifications'
    });
    return state;
  }
}

export const hasGivenAccess = async () => {
  let permission = false;
  if (firebase.messaging.isSupported()) {
    await navigator.permissions
      .query({ name: 'notifications' })
      .then(function (permissionStatus) {
        permission = permissionStatus.state === 'granted';
      });
  }
  return permission;
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('payload', payload);
      resolve(payload);
    });
  });
